import { PROCEDURE_TARGET_EDITION } from '@/modules/copay/entities/enums/procedures';
import { USAGE_STATEMENT_STATUS_FULL } from '@/modules/copay/entities/enums/usageStatement';
import {
  ProcedureToUpdate,
  UsageStatementProcess,
} from '@/modules/copay/entities/interfaces/usageStatements';

export const getCountProceduresMessage = (
  usageStatementProcess?: UsageStatementProcess,
  term = 'descrição',
) => {
  return (usageStatementProcess?.issueProcedures?.length ?? 1) === 1
    ? `Um procedimento sem ${term}`
    : `${usageStatementProcess?.issueProcedures?.length} procedimentos sem ${term}`;
};

export const getCountFieldMissingToFillMessage = (
  total: number,
  countFieldMissingToFill?: number,
) => {
  if (countFieldMissingToFill === 0) {
    return 'Clique em "Enviar" para finalizar a correção.';
  }

  if (countFieldMissingToFill === 1) {
    return `falta 1 de ${total} campos.`;
  }

  return `faltam ${countFieldMissingToFill} de ${total} campos.`;
};

const getFieldMissingToFillMessage = (countFieldMissingDescriptions = 0, total = 0) => {
  return total
    ? `Preencha todos os campos para habilitar o botão. ${getCountFieldMissingToFillMessage(total, countFieldMissingDescriptions)}`
    : 'Nenhum procedimento encontrado.';
};

export const getFieldMissingDescriptionMessage = (
  fieldsByProcedureId: Record<string, { newDescription?: string }>,
  usageStatementProcess?: UsageStatementProcess,
) => {
  const countFieldMissingDescriptions =
    usageStatementProcess?.issueProcedures?.filter(
      (procedure) => !fieldsByProcedureId[procedure.id]?.newDescription,
    ).length || 0;

  return {
    countFieldMissingDescriptions,
    fieldMissingDescriptionMessage: getFieldMissingToFillMessage(
      countFieldMissingDescriptions,
      usageStatementProcess?.issueProcedures?.length || 0,
    ),
  };
};

export const getFieldMissingMessage = (options: {
  fieldsByProcedureId: Record<string, Partial<ProcedureToUpdate>>;
  usageStatementProcess?: UsageStatementProcess;
  fieldsToCount?: (keyof ProcedureToUpdate)[];
}) => {
  const { countFieldMissing = 0, total = 0 } =
    options.usageStatementProcess?.issueProcedures?.reduce(
      (acc, procedure) => {
        Object.entries(options.fieldsByProcedureId[procedure.id]).forEach(([key, value]) => {
          if (options.fieldsToCount?.includes(key as keyof ProcedureToUpdate)) {
            if (value === null || value === undefined || value === '') {
              acc.countFieldMissing += 1;
            }

            acc.total += 1;
          }
        });

        return acc;
      },
      { countFieldMissing: 0, total: 0 },
    ) || {};

  return {
    countFieldMissing,
    fieldMissingMessage: getFieldMissingToFillMessage(countFieldMissing, total),
  };
};

export const getUnauthorizedMessage = (
  usageStatementProcess?: UsageStatementProcess,
  target?: PROCEDURE_TARGET_EDITION,
) => {
  if (usageStatementProcess?.status === USAGE_STATEMENT_STATUS_FULL.FINISHED) {
    return 'Você não pode editar procedimentos de um processo finalizado.';
  }

  if (target === PROCEDURE_TARGET_EDITION.LABEL) {
    if (!usageStatementProcess?.descriptionAddedAt) {
      return 'Aguarde a descrição ser adicionada antes de rotular os procedimentos.';
    }

    return usageStatementProcess?.labelAddedAt
      ? 'Você não tem permissão para editar a rotulação destes procedimentos.'
      : 'Você não tem permissão para rotular este procedimentos.';
  }

  return usageStatementProcess?.descriptionAddedAt
    ? 'Você não tem permissão para editar descrição nestes procedimentos.'
    : 'Você não tem permissão para adicionar descrição nestes procedimentos.';
};
